import { useCallback } from 'react'

import useStoreCurrentUser from '@app/hooks/useStoreCurrentUser'
import track from '@app/lib/analyticsHelper'

type Parms = Parameters<typeof track>
type Tracker = (name: Parms[0], input?: Parms[1]) => void
type UseTrack = () => Tracker

const useTrack: UseTrack = () => {
  const { user } = useStoreCurrentUser()

  return useCallback(
    (name, input = {}) => {
      track(name, input, user)
    },
    [user]
  )
}

export default useTrack
